import { Button } from '../atoms/Button.js';

/**
 * Utility function to detect if a child is a Button component
 * Modern React 19 approach using multiple detection methods
 */
const isButtonComponent = (child) => {
    const childProps = child.props;
    // Method 1: Direct component reference (most reliable in React 19)
    const isButtonComponent = child.type === Button;
    // Method 2: Check data attributes (set during render, not available during children inspection)
    const isButtonByDataAttr = childProps['data-rev-component'] === 'button' || childProps.role === 'button';
    // Method 3: Check if it's the ReactAria Button component or forwardRef Button
    const isReactAriaButton = (typeof child.type === 'function' && child.type.name === 'Button') ||
        child.type?.displayName === 'Button';
    // Method 4: Check for forwardRef Button component (our custom Button uses forwardRef)
    const isForwardRefButton = typeof child.type === 'function' && child.type.displayName === 'Button';
    // Method 5: Check for Button wrapper components (like TopBarSettingsButton, TopBarHelpButton, etc.)
    const isButtonWrapper = typeof child.type === 'function' &&
        (child.type.name?.includes('Button') ||
            child.type.displayName?.includes('Button'));
    return (isButtonComponent ||
        isButtonByDataAttr ||
        isReactAriaButton ||
        isForwardRefButton ||
        isButtonWrapper);
};

export { isButtonComponent };
//# sourceMappingURL=isButtonComponent.js.map
